// extracted by mini-css-extract-plugin
export default {"location":"sLMmsz","location__address":"C2QShu","directions":"iNeqgv","directions__button":"I9_Tq4"};